import Crud from "./baseCrud";
import axios from "axios";

const API_LIST_URL = `/api/problem/list`;
const API_ADD_URL = `/api/problem/add`;
const API_UPDATE_URL = `/api/problem/update`;
const API_DELETE_URL = `/api/problem/delete`;

const NAME_ITEMS = 'problems';
const NAME_ITEM = 'problem';

export default new Crud({
    API_LIST_URL,
    API_ADD_URL,
    API_UPDATE_URL,
    API_DELETE_URL,

    NAME_ITEMS,
    NAME_ITEM
}, {
    state: {
        typeSteps: {
            base: [
                { step: 1, code: 'problem', title: 'Ввод данных'},
                { step: 2, code: 'settings', title: 'Настройки'},
                { step: 3, code: 'adapt', title: 'Адаптация'},
                { step: 4, code: 'predict', title: 'Прогноз'},
            ],
            flooding: [],
            wells: [
                { step: 1, code: 'problem', title: 'Ввод данных'},
                { step: 2, code: 'settings', title: 'Настройки'},
                { step: 3, code: 'wells', title: 'Расстановка скважин и адаптация'},
                { step: 4, code: 'predict', title: 'Прогноз'},
            ]
        },
        analysisTypes: [
            { id: 1, code: 'adapt', title: 'Адаптация', shortTitle: 'Адаптация', description: 'Адаптация' },
            { id: 2, code: 'predict', title: 'Базовый прогноз', shortTitle: 'Прогноз', description: 'Базовый прогноз' },
            { id: 3, code: 'flooding', title: 'Оптимизация заводнения', shortTitle: 'Заводнение', description: 'Подбор программы закачки для максимальной добычи, прогноз' },
            { id: 4, code: 'wells', title: 'Оптимизация сетки скважин', shortTitle: 'Сетка скважин', description: 'Расстановка новых скважин для максимальной добычи, прогноз' },
        ],
        editState: null,
        editProblem: null,
    },
    actions: {
        async loadItem({commit}, itemId) {
            if (!API_LIST_URL) {
                return;
            }

            let response = await axios.post(API_LIST_URL, {filter: {'id': itemId}});
            let item = response.data[NAME_ITEMS][0];
            let problem = item?.problem ? item.problem : item;
            let state = item?.state ? item.state : null;

            await commit('setEditState', state);
            await commit('setEditItem', problem);
            return item;
        },
        async copyItem({commit}, itemId) {
            let response = await axios.post('/api/problem/copy', {'problem_id': itemId});
            let item = response.data[NAME_ITEMS];
            return item;
        },
        async updateItemFields({dispatch, commit, state}, data) {
            try {
                let query = {problem: data};
                let response = await axios.post('/api/problem/updateFields', query);
                let isSuccess = response && response.data && response.data[NAME_ITEM] && response.data[NAME_ITEM].id;
                if (isSuccess) {
                    commit('setSuccessMessage', 'Данные сохранены!', {root: true});
                }
                else {
                    commit('setErrorMessage', 'Ошибка сохранения данных!', { root: true });
                }
            }
            catch (e) {
                commit('setErrorMessage', 'Ошибка сохранения данных!', { root: true })
            }
        },
        async validate(objects, problem) {
            try {
                let response = await axios.post('/api/calc/validate', {problem});
                return response.data;
            }
            catch (e) {
                console.log(e);
            }
            return null;
        },
        async plots(objects, problem) {
            try {
                let response = await axios.post('/api/calc/plots', {problem});
                return response.data;
            }
            catch (e) {
                console.log(e);
            }
            return null;
        },
        async taskGraphs(objects, data) {
            try {
                let response = await axios.post('/api/calc/task_graphs', data);
                return response.data;
            }
            catch (e) {
                console.log(e);
            }
            return null;
        },
        async saveState(objects, data) {
            try {
                await axios.post('/api/problem/saveState', data);
            }
            catch (e) {
                console.log(e);
            }
        },
        async deleteState(objects, data) {
            try {
                await axios.post('/api/problem/deleteState', data);
            }
            catch (e) {}
        },
    },
    mutations: {
        setEditState(state, editState) {
            state.editState = editState;
        },
        setEditProblem(state, problem) {
            state.editProblem = problem;
        }
    }
});
